// App.jsx
import PathfindingVisualizer from './PathfindingVisualizer/PathfindingVisualizer.jsx';
import './App.css';

function App() {
  return (
    <div className="App">
      <PathfindingVisualizer />
    </div>
  );
}

export default App;